import overstock from "./overstock.png";
import "./Projects.css";
import forestEssentials from "./forestEssentials.png";
import weather from "./weather.png";
import koo from "./koo.png";


export const Projects = () => {

  return (
    <div className="ProjectCont">
      <div className="projectHeading">
        <div>Projects</div>
      </div>
      <div className="Projects">
        <div className="Project">
          <div>
            <img src={forestEssentials} alt="" />
          </div>
          <div className="ProjectContent">
            <div>
              <h1>Forest Essential Clone</h1>
              <p>
                This website is the Clone of forestessentialindia.com in which I
                implemented some cool functionalities like Cart functionalities,
                dynamic individual Project page, landing page with many sliders
                and many more.{" "}
              </p>
              <p>
                <span>Teck Stack :</span>
                HTML , CSS , JavaScript
              </p>
            </div>
            <div>
              <div className="demoVideo"><a href="https://youtu.be/OPjaDA52r7M" target="_blank" rel="noopener noreferrer">Video Demo</a></div>
              <div className="deployment">
                <a href="https://forestessential.netlify.app/" target="_blank">
                  Deployment
                </a>
              </div>
              <div className="sourceCode">
                <a
                  href="https://github.com/rahulkumarmbd/forestessential_clone"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Source Code
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="Project">
          <div>
            <img src={overstock} alt="" />
          </div>
          <div className="ProjectContent">
            <div>
              <h1>OverStock Clone</h1>
              <p>
                This website is the Clone of OverStock.com in which I
                implemented some cool functionalities like Google Authentication
                system, Email verification system , Project Page and many more.{" "}
              </p>
              <p>
                <span>Teck Stack :</span>
                HTML , CSS , Advanced JavaScript , mongoDB , Express JS, Node JS
              </p>
            </div>
            <div>
              <div className="demoVideo">
                <a
                  target="_blank"
                  href="https://www.youtube.com/watch?v=jCfaaAJu8hg&t=85s"
                >
                  Video Demo
                </a>
              </div>
              <div className="deployment">
                <a href="https://overstockv2.netlify.app/" target="_blank">
                  Deployment
                </a>
              </div>
              <div className="sourceCode">
                <a
                  href="https://github.com/rahulkumarmbd/overStock-Clone"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Source Code
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="Project">
          <div>
            <img src={koo} alt="" />
          </div>
          <div className="ProjectContent">
            <div>
              <h1>Koo App Clone</h1>
              <p>
                KooApp is an alternative app to Twitter , built for Indians in order to be able to share their views using Indian language.
              </p>
              <p>
                <span>Teck Stack :</span>
                HTML , CSS , React JS , Node , Express , MongoDB , AWS.
              </p>
            </div>
            <div>
              <div className="demoVideo">
                <a
                  href="https://drive.google.com/file/d/1I42fCSzm7Evni5Rzr3BkENXwif7h0bsT/view?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                >Video Demo</a>
              </div>
              <div className="deployment">
                <a
                  href="https://koo-app-clone.netlify.app/"
                  target="_blank"
                >
                  Deployment
                </a>
              </div>
              <div className="sourceCode">
                <a
                  href="https://github.com/rahulkumarmbd/kooAppFrontend"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Source Code
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="Project">
          <div>
            <img src={weather} alt="" />
          </div>
          <div className="ProjectContent">
            <div>
              <h1>Weather Application</h1>
              <p>
                This is the mini-Project in which you can check the weather of
                any place all over the world.
              </p>
              <p>
                <span>Teck Stack :</span>
                HTML , CSS , Advanced JavaScript , Google apis.
              </p>
            </div>
            <div>
              <div className="demoVideo">
                <a
                  href="https://drive.google.com/file/d/1qWUjDtHoVCFcaCg4picDaL0xC2J0xHDv/view?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                >Video Demo</a>
              </div>
              <div className="deployment">
                <a
                  href="https://weatherbyjavascript.netlify.app/"
                  target="_blank"
                >
                  Deployment
                </a>
              </div>
              <div className="sourceCode">
                <a
                  href="https://github.com/rahulkumarmbd/weatherProject"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Source Code
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
